<template>
  <div>
    <h3 style="text-align: center;"><b>BÁO CÁO HỢP ĐỒNG (CHƯA CÓ MẪU)</b></h3>

    <b-table
      id="my-table"
      bordered
      head-variant="dark"
      hover
      striped
      responsive
      small
      :fields="fields"
      :items="items"
      table-variant="light"
    >
      <template #cell(STT)="data">
        {{ data.index + 1 }}
      </template>
      <template v-slot:cell(ngaysinh)="data">{{
        formatDate(data.value)
      }}</template>
      <template v-slot:cell(ngaythuviec)="data">{{
        formatDate(data.value)
      }}</template>
      <template v-slot:cell(ngaychinhthuc)="data">{{
        formatDate(data.value)
      }}</template>
    </b-table>
    <b-badge variant="light">Tổng số: {{ totalRow }}</b-badge>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Report2",
  props: ["customer"],
  data() {
    return {
      field: [],
      // fields: [
      //   {
      //     key: "STT",
      //     label: "STT",
      //     thClass: "align-middle",
      //     thStyle: {width: "15px", textAlign : "center"},
      //   },
      //   {
      //     key: "ten",
      //     label: "Khách hàng",
      //     sortable: true,
      //     thClass: "align-middle",
      //     thStyle: { textAlign : "center" },
      //   },
      //   {
      //     key: "contact_ten",
      //     label: "Người phụ trách",
      //     sortable: true,
      //     thClass: "align-middle",
      //     thStyle: { width: "180px !important", textAlign : "center" },
      //   },
      //   {
      //     key: "contact_chucdanh",
      //     label: "Chức danh",
      //     sortable: true,
      //     thClass: "align-middle",
      //     thStyle: { width: "180px !important", textAlign : "center" },
      //   },
      //   {
      //     key: "contact_dienthoai",
      //     label: "Điện thoại",
      //     sortable: true,
      //     thClass: "align-middle",
      //     thStyle: { width: "120px !important", textAlign : "center" },
      //   },
      //   {
      //     key: "contact_diachi",
      //     label: "Điạ chỉ",
      //     sortable: true,
      //     thClass: "align-middle",
      //     thStyle: { textAlign : "center" },
      //   },
      // ],
      items: [],
      totalRow: null,
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      let query = Object.assign({}, this.$route.query);
      query.report = 2;
      // query.customer = this.customer;
      axios
        .get(`/api/customercontractreport/get`, { params: query })
        .then((response) => {
          this.items = response.data.items;
          this.totalRow = response.data.totalRow;
        })
        .catch((err) => {});
    },
    findFirst(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });
      return temp == null ? "" : temp.pickListValue;
    },
    findFirstDepartment(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });
      return temp == null ? "" : temp.tendonvi;
    },
    formatDate(value) {
      if (!value) return "";
      return this.$moment(value).format("DD/MM/YYYY");
    },
    paginationChanged(ctx) {
      let query = Object.assign({}, this.$route.query);
      query.page = ctx;
      this.$router.push({ query: query });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
